import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
import { useSession } from 'next-auth/react';
import { usePathname } from 'src/routes/hook';
// components

import SvgColor from 'src/components/svg-color';
import Label from 'src/components/label';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  chat: icon('ic_chat'),
  user: icon('ic_user'),
  product: icon('ic_product'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  label: icon('ic_label'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();
  const { data: session } = useSession();
  const pathname = usePathname();
  const isDemo = pathname.startsWith('/demo');

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: "Storefront Stalker Pro",
        items: [
          { title: t('Home'), path: paths.dashboard.root, icon: ICONS.analytics },
          { title: t('Manage Storefronts'), path: paths.dashboard.general.storefronts, icon: ICONS.product },
          { title: t('Suggested Storefronts'), path: paths.dashboard.general.topstores, icon: ICONS.label },
          { title: t('Virtual Assistants'), path: paths.dashboard.general.virtualAgents, icon: ICONS.user, info: <Label color="error">NEW</Label> }
        ],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      // {
      //   subheader: t('management'),
      //   items: [
      //     // USER
      //     {
      //       title: t('user'),
      //       path: paths.dashboard.user.root,
      //       icon: ICONS.user,
      //       children: [
      //         { title: t('profile'), path: paths.dashboard.user.root },
      //         { title: t('account'), path: paths.dashboard.user.account },
      //       ],
      //     },

      //     // PRODUCT
      //     {
      //       title: t('product'),
      //       path: paths.dashboard.product.root,
      //       icon: ICONS.product,
      //       children: [
      //         { title: t('list'), path: paths.dashboard.product.root },
      //         { title: t('details'), path: paths.dashboard.product.demo.details },
      //         { title: t('create'), path: paths.dashboard.product.new },
      //         { title: t('edit'), path: paths.dashboard.product.demo.edit },
      //       ],
      //     },


      //     //CHAT
      //     {
      //       title: t('chat'),
      //       path: paths.dashboard.chat,
      //       icon: ICONS.chat,
      //     },
      //   ],
      // },
    ],
    [t]
  );

  if (isDemo) {
    return data.map(group => ({
      ...group,
      items: group.items.map(item => ({
        ...item,
        path: item.path.replace('/dashboard', '/demo')
      }))
    }));
  }

  return data;
}
